<template lang="pug">
.video-section(v-if="playlist && playlist.length")
  .headers
    .header.selected Videos
  .videos(@drop.prevent="drop")
    a.video(v-for="({ id, t, d, pa, ct, u, du, ce }, index) in playlist",
            :class="{ playing: currentVideo && currentVideo.id === id, 'no-embed': !ce, 'drop-target': editable && index === dropBefore }",
            :id="`v|${ id }`",
            :draggable="editing",
            @dragstart="start",
            @dragover.prevent="vidOver(id)",
            @click.stop="ce && playVidById(id)",
            :href="!ce && `https://www.youtube.com/watch?v=${ id }` || null"
            :target="!ce && '_blank' || null")
      //-@scroll="videosScroll")
      .delete(@click.stop="deleteVideo(id)", :title="`Remove ${ t }`")
      .bg(:id="id", :style="{ 'background-image': `url('https://i.ytimg.com/vi/${ id }/mqdefault.jpg')` }")
        .duration {{ Math.floor(du / 60) }}:{{ (du % 60 + '0').replace(/^(\d\d)\d/, '$1') }}
        .source(v-if="u", :style="{ 'background-image': u && `url('${ u }')` || '' }", :title="ct")
      .info
        .bap(:title="`Play ${ t }`")
        .source(v-if="u", :style="{ 'background-image': u && `url('${ u }')` || '' }", :title="ct")
        .details
          .title {{ t }}
          .description {{ d }}
          .date(v-if="pa") {{ date(pa) | moment('from', 'now') }}
          .duration {{ Math.floor(du / 60) }}:{{ (du % 60 + '0').replace(/^(\d\d)\d/, '$1') }}
</template>
<script>
import { mapActions } from 'vuex';
import { vuexComputed, moveOrAdd } from '@/helpers';
export default {
  name: 'videos',
  props: {
    playlist: Array,
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...vuexComputed(
      'lazyLevel',
      'sharing',
      'editing',
      'dragType',
      'dropBefore',
      'currentVideo',
      'robo',
      'collapsed'
    ),
    editing() {
      const { editable, $store: { getters } } = this;
      return editable && getters.editing;
    }
  },
  methods: {
    ...mapActions(['deleteVideo']),
    date(pa) {
      return new Date(pa);
    },
    playVidById(id) {
      const [vid] = this.playlist?.filter(vid => vid.id === id) || [];
      console.log('playVidById:', vid, this.robo);
      if (vid) {
        this.currentVideo = vid;
        if (this.robo) {
          this.collapsed = false;
        }
        this.$store.dispatch('playlist', this.playlist);
      }
    },
    start({ dataTransfer, target: { id }, target, preventDefault }) {
      const stripper = /^([dvpit])\|/;
      const chararcter = (stripper.exec(id) || [])[1];
      console.log('chararcter', chararcter);
      const { playlist } = this;
      const actions = {
        v() {
          const [vid] = playlist?.filter(vid => vid.id === id.replace(stripper, '')) || [];
          if (vid) {
            dataTransfer.setData('text/plain', 'v|' + JSON.stringify(vid));
            //this.editingReadingList = false;
            //this.dragType = 'video';
          } else {
            // this is throwing
            //preventDefault();
          }
        }
      };
      actions.d = actions.i = actions.t = actions.p = setId;
      (actions[chararcter] || actions.v)();
      function setId() {
        dataTransfer.setData('text/plain', id);
      }
    },
    vidOver(id) {
      const { playlist } = this;
      const [dropBefore] = playlist?.filter(v => v.id === id.replace(/^v\|/, '')) || [];
      const index = playlist?.indexOf(dropBefore);
      this.dragType = 'video';
      this.dropBefore = index;
      //const index = target.getAttribute('index') * 1;
      //console.log('over', index);
      // window.over = [index, id, target];
      // window.over = [/^v\|/.test(dataTransfer.getData('text/plain'), dataTransfer.getData('text/plain'))];
      // if (this.dragType !== 'video' && /^v\|/.test(dataTransfer.getData('text/plain'))) {
      // }
      // if (this.dragType === 'video') {
      // }
    },
    drop(e) {
      const { dropBefore: to, playlist, dragType } = this;
      const { dataTransfer } = e;
      const data = dataTransfer.getData('text/plain');
      const stripper = /^([dvpit])\|/;
      const stripped = (data || '').replace(stripper, '');
      const character = (stripper.exec(data) || [])[1];
      const kind = ({ d: 'document', v: 'video', p: 'page', i: 'insight', t: 'tweet' })[character];
      console.log('drop kind', character, kind, dragType, data, stripped);
      if (kind === 'video' && dragType === 'video') {
        try {
          let vid = JSON.parse(stripped || '0');
          if (vid) {
            // console.log('vid is', vid);
            const [sameVid] = this.playlist?.filter(v => v.id === vid.id) || [];
            vid = sameVid || vid;
            this.dropBefore = null;
            moveOrAdd(playlist, to, vid);// && (this.playlist = playlist);
          }
        } catch(ex) {
          console.log('video drop parse error?', ex);
        } finally {
          this.dropBefore = null;
        }
      } else {
        console.log('wrong drag type, was', dragType || 'null', 'expected video, document, or page');
      }
      this.dropBefore = null;
    },
    delete(id) {
      this.deleteVideo(id);
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.video-section {
  margin-top: 3rem;
  .headers {
    background-color: white;
  }
  .videos {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    a.video {
      position: relative;
      display: inline-block;
      width: 22%;
      padding-top: 12.35%;
      margin: 1rem 1.5%;
      transition: transform 250ms ease-in-out;
      will-change: transform;
      &:not([draggable="true"]):hover {
        z-index: 3;
        .bg {
          transform: translate3d(0, 95%, 0);
        }
        .info {
          opacity: 1;
        }
      }
      &.drop-target {
        transform: translate3d(1.5rem, 0, 0);
        &::before {
          content: '\00a0';
          position: absolute;
          top: 0;
          left: -1rem;
          height: 100%;
          width: 0.25rem;
          background-color: $brn;
        }
      }
      &.playing {
        .bg {
          &::after {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            content: '\00a0';
            background: rgba(40, 40, 40, 0.4) center no-repeat
              url("data:image/svg+xml;charset%3Dutf8,%3Csvg height%3D'6.827in' viewBox%3D'0 0 6.827 6.827' width%3D'6.827in' xmlns%3D'http://www.w3.org/2000/svg'%3E%3Cpath fill%3D'white' d%3D'M2.83373 4.08723c0.234571,-0.12152 0.468327,-0.242677 0.702075,-0.363862 0.229406,-0.118933 0.458823,-0.237913 0.689008,-0.357299 -0.255059,-0.133181 -0.508724,-0.265543 -0.762114,-0.397764 -0.209614,-0.109378 -0.419059,-0.218677 -0.628969,-0.328256l0 1.44718zm0.750823 -0.26928c-0.259551,0.134563 -0.51911,0.269091 -0.779783,0.404118l-0.0777087 0.040252 0 -0.0875433 0 -1.62249 0 -0.0877638 0.0779173 0.0406811c0.236012,0.123224 0.471343,0.246024 0.706886,0.368933 0.283362,0.147858 0.567059,0.295898 0.852677,0.445059l0.0905591 0.0472953 -0.0907677 0.0470787c-0.260673,0.135205 -0.520232,0.269819 -0.77978,0.404378z'/%3E%3Cpath fill%3D'white' d%3D'M5.83278 4.58511c-0.0327126,0.14115 -0.106701,0.263898 -0.20726,0.355248 -0.101142,0.091874 -0.229165,0.152126 -0.369209,0.16763 -0.305,0.0341142 -0.612587,0.0512874 -0.921185,0.0598937 -0.306618,0.00855118 -0.614535,0.00855118 -0.921929,0.00837402 -0.307256,0.000177165 -0.615177,0.000177165 -0.921839,-0.00837402 -0.308642,-0.0086063 -0.616319,-0.0257795 -0.921354,-0.0598937 -0.140071,-0.0155039 -0.268122,-0.0757756 -0.36922,-0.167677 -0.100508,-0.0913583 -0.174394,-0.214094 -0.206894,-0.355201 -0.0436378,-0.189098 -0.0654331,-0.386354 -0.0763071,-0.584752 -0.0109252,-0.199445 -0.0109291,-0.395992 -0.0109291,-0.586795 0,-0.191055 0.000279528,-0.387858 0.0114685,-0.587185 0.0111457,-0.198484 0.0332087,-0.395748 0.0768228,-0.584815 0.0323071,-0.141047 0.106157,-0.263748 0.206673,-0.35511 0.101157,-0.0919528 0.229335,-0.15226 0.369445,-0.167764 0.304996,-0.0341181 0.612673,-0.0512913 0.921315,-0.0599016 0.306665,-0.00855118 0.614587,-0.00855118 0.921799,-0.00837402 0.307256,-0.000177165 0.615197,-0.000177165 0.921823,0.00837402 0.308606,0.00861024 0.616193,0.0257835 0.921016,0.0599016 0.140244,0.0154961 0.268476,0.0757756 0.369728,0.167689 0.100626,0.0913504 0.174594,0.214075 0.207094,0.355185 0.0859488,0.37402 0.0859488,0.779492 0.0859409,1.16233l0.000208661 0 0 0.00967323 -0.000208661 0c1.5748e-005,0.192681 -7.48031e-005,0.391154 -0.0108425,0.586795 -0.0109134,0.19839 -0.0327126,0.395646 -0.0761575,0.584752zm-0.278929 0.2765c0.0849961,-0.0772126 0.147535,-0.180961 0.175181,-0.300248 0.0419449,-0.182579 0.0630433,-0.373945 0.0736535,-0.566839 0.0107638,-0.19563 0.0108543,-0.391161 0.0108425,-0.580961l-0.000208661 0 0 -0.00967323 0.000208661 0c3.93701e-006,-0.376594 7.87402e-006,-0.775457 -0.083437,-1.13858 -0.0274685,-0.119264 -0.0899803,-0.222992 -0.175016,-0.300185 -0.0849213,-0.0770866 -0.19235,-0.12763 -0.309728,-0.140602 -0.30328,-0.0339488 -0.607673,-0.0509882 -0.91226,-0.0594843 -0.306567,-0.00854724 -0.613094,-0.00854724 -0.918909,-0.00837402 -0.305772,-0.000173228 -0.61228,-0.000173228 -0.918886,0.00837402 -0.304618,0.00849606 -0.609102,0.0255394 -0.912559,0.0594843 -0.117224,0.0129724 -0.224587,0.0635433 -0.309445,0.140677 -0.0848898,0.0771614 -0.14728,0.180858 -0.174594,0.30011 -0.0421299,0.182626 -0.0634843,0.373984 -0.0743189,0.566902 -0.0107835,0.192075 -0.0110512,0.389496 -0.0110512,0.58135 0,0.191677 0,0.38913 0.0105118,0.580961 0.0105709,0.192882 0.0316654,0.384244 0.0738031,0.566839 0.0274724,0.119291 0.0899055,0.22302 0.174815,0.300201 0.0847992,0.0770866 0.192043,0.127618 0.30922,0.140591 0.303492,0.0339449 0.607976,0.0509843 0.912598,0.0594764 0.306602,0.00854724 0.61311,0.00854724 0.918925,0.00837402 0.305953,0.000173228 0.612457,0.000173228 0.919016,-0.00837402 0.304579,-0.00849213 0.608972,-0.0255354 0.912429,-0.0594764 0.117157,-0.0129724 0.224382,-0.0634882 0.309209,-0.140543z'/%3E%3C/svg%3E");
            background-size: 8rem;
          }
        }
      }
      .bg {
        will-change: transform;
        transition: transform 250ms ease-in-out;
        transform: translate3d(0, 0, 0);
        border-radius: 3px;
        box-shadow: 0 0 5px #989898, 0 0 15px #989898;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: white no-repeat center;
        background-size: cover;
        .duration {
          position: absolute;
          bottom: 0.5rem;
          left: 3rem;
          color: white;
          text-shadow: 1px 1px 1px #black,
                       -1px -1px 1px #black,
                       -1px 1px 1px #black,
                       1px -1px 1px #black
                       1px 1px 1px #black,
                       -1px -1px 1px #black,
                       -1px 1px 1px #black,
                       1px -1px 1px #black;

        }
        .source {
          position: absolute;
          left: 0.5rem;
          bottom: 0.5rem;
          height: 2rem;
          width: 2rem;
          background: no-repeat center;
          background-size: contain;
          border-radius: 50%;
        }
      }
      .info {
        box-sizing: border-box;
        padding: 0.25rem;
        border: 1px solid #ccc;
        border-radius: 4px;
        opacity: 0;
        will-change: opacity;
        transition: opacity 250ms ease-in-out;
        z-index: -1;
        position: absolute;
        top: 0.5rem;
        left: 0.5rem;
        bottom: 0.5rem;
        right: 0.5rem;
        .bap {
          cursor: pointer;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 5rem;
          background: no-repeat center bottom
            url("data:image/svg+xml;charset%3Dutf8,%3Csvg height%3D'6.827in'  viewBox%3D'0 0 6.827 6.827' width%3D'6.827in' xmlns%3D'http://www.w3.org/2000/svg'%3E%3Cpath fill%3D'%238d6e4f' d%3D'M2.83373 4.08723c0.234571,-0.12152 0.468327,-0.242677 0.702075,-0.363862 0.229406,-0.118933 0.458823,-0.237913 0.689008,-0.357299 -0.255059,-0.133181 -0.508724,-0.265543 -0.762114,-0.397764 -0.209614,-0.109378 -0.419059,-0.218677 -0.628969,-0.328256l0 1.44718zm0.750823 -0.26928c-0.259551,0.134563 -0.51911,0.269091 -0.779783,0.404118l-0.0777087 0.040252 0 -0.0875433 0 -1.62249 0 -0.0877638 0.0779173 0.0406811c0.236012,0.123224 0.471343,0.246024 0.706886,0.368933 0.283362,0.147858 0.567059,0.295898 0.852677,0.445059l0.0905591 0.0472953 -0.0907677 0.0470787c-0.260673,0.135205 -0.520232,0.269819 -0.77978,0.404378z'/%3E%3Cpath fill%3D'%238d6e4f' d%3D'M5.83278 4.58511c-0.0327126,0.14115 -0.106701,0.263898 -0.20726,0.355248 -0.101142,0.091874 -0.229165,0.152126 -0.369209,0.16763 -0.305,0.0341142 -0.612587,0.0512874 -0.921185,0.0598937 -0.306618,0.00855118 -0.614535,0.00855118 -0.921929,0.00837402 -0.307256,0.000177165 -0.615177,0.000177165 -0.921839,-0.00837402 -0.308642,-0.0086063 -0.616319,-0.0257795 -0.921354,-0.0598937 -0.140071,-0.0155039 -0.268122,-0.0757756 -0.36922,-0.167677 -0.100508,-0.0913583 -0.174394,-0.214094 -0.206894,-0.355201 -0.0436378,-0.189098 -0.0654331,-0.386354 -0.0763071,-0.584752 -0.0109252,-0.199445 -0.0109291,-0.395992 -0.0109291,-0.586795 0,-0.191055 0.000279528,-0.387858 0.0114685,-0.587185 0.0111457,-0.198484 0.0332087,-0.395748 0.0768228,-0.584815 0.0323071,-0.141047 0.106157,-0.263748 0.206673,-0.35511 0.101157,-0.0919528 0.229335,-0.15226 0.369445,-0.167764 0.304996,-0.0341181 0.612673,-0.0512913 0.921315,-0.0599016 0.306665,-0.00855118 0.614587,-0.00855118 0.921799,-0.00837402 0.307256,-0.000177165 0.615197,-0.000177165 0.921823,0.00837402 0.308606,0.00861024 0.616193,0.0257835 0.921016,0.0599016 0.140244,0.0154961 0.268476,0.0757756 0.369728,0.167689 0.100626,0.0913504 0.174594,0.214075 0.207094,0.355185 0.0859488,0.37402 0.0859488,0.779492 0.0859409,1.16233l0.000208661 0 0 0.00967323 -0.000208661 0c1.5748e-005,0.192681 -7.48031e-005,0.391154 -0.0108425,0.586795 -0.0109134,0.19839 -0.0327126,0.395646 -0.0761575,0.584752zm-0.278929 0.2765c0.0849961,-0.0772126 0.147535,-0.180961 0.175181,-0.300248 0.0419449,-0.182579 0.0630433,-0.373945 0.0736535,-0.566839 0.0107638,-0.19563 0.0108543,-0.391161 0.0108425,-0.580961l-0.000208661 0 0 -0.00967323 0.000208661 0c3.93701e-006,-0.376594 7.87402e-006,-0.775457 -0.083437,-1.13858 -0.0274685,-0.119264 -0.0899803,-0.222992 -0.175016,-0.300185 -0.0849213,-0.0770866 -0.19235,-0.12763 -0.309728,-0.140602 -0.30328,-0.0339488 -0.607673,-0.0509882 -0.91226,-0.0594843 -0.306567,-0.00854724 -0.613094,-0.00854724 -0.918909,-0.00837402 -0.305772,-0.000173228 -0.61228,-0.000173228 -0.918886,0.00837402 -0.304618,0.00849606 -0.609102,0.0255394 -0.912559,0.0594843 -0.117224,0.0129724 -0.224587,0.0635433 -0.309445,0.140677 -0.0848898,0.0771614 -0.14728,0.180858 -0.174594,0.30011 -0.0421299,0.182626 -0.0634843,0.373984 -0.0743189,0.566902 -0.0107835,0.192075 -0.0110512,0.389496 -0.0110512,0.58135 0,0.191677 0,0.38913 0.0105118,0.580961 0.0105709,0.192882 0.0316654,0.384244 0.0738031,0.566839 0.0274724,0.119291 0.0899055,0.22302 0.174815,0.300201 0.0847992,0.0770866 0.192043,0.127618 0.30922,0.140591 0.303492,0.0339449 0.607976,0.0509843 0.912598,0.0594764 0.306602,0.00854724 0.61311,0.00854724 0.918925,0.00837402 0.305953,0.000173228 0.612457,0.000173228 0.919016,-0.00837402 0.304579,-0.00849213 0.608972,-0.0255354 0.912429,-0.0594764 0.117157,-0.0129724 0.224382,-0.0634882 0.309209,-0.140543z'/%3E%3C/svg%3E");
          background-size: contain;
          opacity: 0.5;
          will-change: opacity;
          transition: opacity 250ms ease-in-out;
          &:hover {
            opacity: 1;
          }
        }
        .title {
          @include pubTitle;
          margin-bottom: 0.5rem;
        }
        .description {
          text-align: left;
          font-size: 0.9rem;
        }
        .source {
          position: absolute;
          left: 0.5rem;
          bottom: 0.5rem;
          height: 2rem;
          width: 2rem;
          background: no-repeat center;
          background-size: contain;
        }
        .date {
          position: absolute;
          bottom: 0.5rem;
          right: 0.5rem;
        }
        .duration {
          position: absolute;
          bottom: 0.5rem;
          left: 3rem;
        }
      }
    }
  }
}
</style>
